<template>
<div>
  <b-row>
    <b-col cols="3">
      <b-form-group label="Disabled">
          <b-form-checkbox
            v-model="activeField.disabled"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>

    <b-col cols="3">
      <b-form-group label="Step">
        <b-form-input v-model="activeField.step"></b-form-input>
      </b-form-group>
    </b-col>

    <b-col cols="3">
      <b-form-group label="Step Strictly">
          <b-form-checkbox
            v-model="activeField.stepStrictly"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col cols="3">
      <b-form-group label="Is Currency">
          <b-form-checkbox
            v-model="activeField.isCurrency"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Min Value">
          <b-form-checkbox
            v-model="activeField.hasMinValue"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-group label="Max Value">
          <b-form-checkbox
            v-model="activeField.hasMaxValue"
            switch></b-form-checkbox>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Min Value" v-show="activeField.hasMinValue">
          <b-form-input v-model="activeField.min" type="number" :step="activeField.step"></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-group label="Max Value" v-show="activeField.hasMaxValue">
          <b-form-input v-model="activeField.max" type="number" :step="activeField.step"></b-form-input>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Prepend">
        <b-form-input v-model="activeField.prepend"></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="6">
      <b-form-group label="Append">
        <b-form-input v-model="activeField.append"></b-form-input>
      </b-form-group>
    </b-col>
  </b-row>
</div>
</template>
<script>
export default {
  name: 'NumberInputAdvancedProps',
  store: ['activeField']
}
</script>
